import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import CustomTable from './CustomTable'
import { TenantBizFieldServiceProxy, TenantCustomBizFieldUpdateDTO, TenantBizDataTypeDTO, TenantBizInitFieldDTO } from '@/service-proxies/app-v2/system.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import './bill.less'
import { deepClone } from '@/utils'
const dictService = new DictServiceProxy()
const tenantBizField = new TenantBizFieldServiceProxy()

@Component({
  name: 'bill-product',
  components: {
    CustomTable
  }
})
export default class BillProduct extends Vue {
  @Prop() isShow: Boolean
  @Ref() customTable: CustomTable

  cacheData = []
  fieldTypes = []
  tags = []
  bizCode = ''
  dataType = ''
  dataName = ''
  loading = false
  scrollY = 0

  loadTable(value) {
    this.tags = []
    if (value.dataId !== '') {
      this.bizCode = value.bizCode
      this.select(value.dataId)
    } else {
      this.bizCode = value.bizCode
      this.loading = true
      tenantBizField.getTenantBizDataTypeList(this.bizCode).then(res => {
        if (res && res.length > 0) {
          this.loading = false
          this.select(res[0].bizDataId)
          this.dataName = res[0].bizDataName
          let temp = deepClone(res)
          temp.map(item => {
            if (item.bizDataId > 0 && item.bizDataId < 8) {
              item.key = 'page_plan_type_' + item.bizDataId
            }
          })
          this.tags = temp
        } else {
          this.select(undefined)
        }
      })
    }
  }

  handleTypeChange(value) {
    console.log(value)
    let a = this.dataType
    this.dataType = value
    if (this.customTable.Rowkey !== '') {
      const ok: any = this.$t('ok')
      const cancel: any = this.$t('cancel')
      this.$confirm({
        title: this.$t('page_bill_settings_has_edit_content'),
        content: this.$t('page_bill_settings_switch_type'),
        okText: ok,
        okType: 'danger',
        cancelText: cancel,
        onOk: () => {
          this.customTable.Rowkey = ''
          this.select(value)
        },
        onCancel: () => {
          this.dataType = a
        },
      });
    } else {
      this.select(value)
    }
  }

  select(value) {
    const div = document.getElementById('black-main')
    this.scrollY = div.clientHeight - 100
    this.dataType = value
    if(this.tags && this.tags.length){
      const data = this.tags.find(res => res.bizDataId === value)
      if(data){
        this.dataName = data.bizDataName
      }
    }
    this.customTable.getData(this.bizCode, value)
  }

  save() {
    this.customTable.save()
  }

  reset() {
    tenantBizField.resetTenantCustomBizField(this.bizCode, this.dataType, this.dataName).then(res => {
      this.customTable.getData(this.bizCode, this.dataType)
      this.$message.success(this.$t('page_user_management_reset_successful'))
    })
  }

  reloadSettings() { // 还原默认配置
    const ok: any = this.$t('ok')
    const cancel: any = this.$t('cancel')
    this.$confirm({
      title: this.$t('page_bill_settings_resetdefault'),
      content: this.$t('page_bill_settings_to_resetdefault'),
      okText: ok,
      okType: 'danger',
      cancelText: cancel,
      onOk: () => {
        this.reset()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  callback(val) {
    console.log(val);
  }
  render() {
    return (
      <blank-view>
        <div slot={'action'}>
          <a-button
            v-acl="page_bill_settings_save"
            type="primary"
            disabled={!this.isShow}
            onClick={() => this.save()}
          >
            {this.$t('save')}
          </a-button>
          <a-button
            v-acl="page_bill_settings_reset"
            type="danger"
            disabled={!this.isShow}
            style="margin-left: 8px;"
            onClick={() => this.reloadSettings()}
          >
            {this.$t('page_bill_settings_resetdefault')}
          </a-button>
        </div>
        <div>
          {(this.tags.length > 0) ?
            <a-select value={this.dataType} style="width: 220px;margin-bottom: 8px;" showSearch onChange={e => this.handleTypeChange(e)}>
              {
                this.tags.map(item => {
                  return <a-select-option key={item.bizDataId}>{item.key ? this.$t(item.key) : item.bizDataName}</a-select-option>
                })
              }
            </a-select> : null
          }
          <custom-table ref="customTable" scrollY={this.scrollY}></custom-table>
        </div>
      </blank-view>
    )
  }
}
